var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.links)?_c('Iframe',{staticClass:"fill-height fill-width",attrs:{"link":_vm.links.affluenceUrl,"title":"Affluence"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }